var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@apollo/client';
import Paper from '@mui/material/Paper';
import MuiPopper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';
import { ACKNOWLEDGE_NEW_FEATURE } from 'common/graphql/mutations/system-config/acknowledge-new-feature';
import { IS_USER_ACKNOWLEDGED_NEW_FEATURE } from 'common/graphql/queries/system-config/is-user-acknowledged-new-feature';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import Button from 'components/Buttons/Button';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeNewFeaturePopperDialog } from 'store/actions/base/new-feature-popper.actions';
// const Popper = styled(MuiPopper, {
var Popper = styled(MuiPopper, {
    shouldForwardProp: function (prop) { return prop !== 'arrow'; }
})(function (_a) {
    var theme = _a.theme, arrow = _a.arrow;
    return ({
        zIndex: 1,
        '& > div': {
            position: 'relative'
        },
        '&[data-popper-placement*="bottom"]': {
            '& > div': {
                marginTop: 0
            },
            '& .MuiPopper-arrow': {
                top: 0,
                left: 0,
                marginTop: '-0.9em',
                width: '5em',
                height: '3em',
                '&::before': {
                    borderWidth: '0 3em 3em 3em',
                    borderColor: "transparent transparent #dbb400 transparent"
                }
            }
        },
        '&[data-popper-placement*="top"]': {
            '& > div': {
                marginBottom: 0
            },
            '& .MuiPopper-arrow': {
                bottom: 0,
                left: 0,
                marginBottom: '-0.9em',
                width: '5em',
                height: '3em',
                '&::before': {
                    borderWidth: '3em 3em 0 3em',
                    borderColor: "#dbb400 transparent transparent transparent"
                }
            }
        },
        '&[data-popper-placement*="right"]': {
            '& > div': {
                marginLeft: arrow ? 2 : 0
            },
            '& .MuiPopper-arrow': {
                left: 0,
                marginLeft: '-0.9em',
                height: '5em',
                width: '3em',
                '&::before': {
                    borderWidth: '3em 3em 3em 0',
                    borderColor: "transparent #dbb400 transparent transparent"
                }
            }
        },
        '&[data-popper-placement*="left"]': {
            '& > div': {
                marginRight: arrow ? 2 : 0
            },
            '& .MuiPopper-arrow': {
                right: 0,
                marginRight: '-0.9em',
                height: '5em',
                width: '3em',
                '&::before': {
                    borderWidth: '3em 0 3em 3em',
                    borderColor: "transparent transparent transparent #dbb400"
                }
            }
        }
    });
});
var Arrow = styled('div')({
    position: 'absolute',
    fontSize: 7,
    width: '5em',
    height: '5em',
    color: '#dbb400',
    '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid'
    }
});
var NewFeaturePopper = function (_a) {
    var newFeatureId = _a.newFeatureId, activeUntilDateStr = _a.activeUntilDateStr, anchorEl = _a.anchorEl, text = _a.text, buttonText = _a.buttonText, placement = _a.placement;
    var t = useTranslation().t;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(null), arrowRef = _c[0], setArrowRef = _c[1];
    var dispatch = useDispatch();
    var data = useQuery(IS_USER_ACKNOWLEDGED_NEW_FEATURE, {
        skip: new Date() > new Date(activeUntilDateStr),
        variables: {
            id: newFeatureId
        }
    }).data;
    var acknowledgeNewFeature = function (_) {
        return useMutation(ACKNOWLEDGE_NEW_FEATURE, {
            variables: {
                id: newFeatureId
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: IS_USER_ACKNOWLEDGED_NEW_FEATURE,
                    variables: {
                        id: newFeatureId
                    }
                },
            ]
        });
    };
    useEffect(function () {
        if (data && data.isUserAcknowledgedNewFeature === false) {
            setIsOpen(true);
        }
    }, [data]);
    var onAcknowledge = function () {
        setIsOpen(false);
        dispatch(closeNewFeaturePopperDialog());
    };
    var _d = useDynamicMutation(acknowledgeNewFeature, onAcknowledge, onAcknowledge), handleExecuteMutation = _d.handleExecuteMutation, loading = _d.loading;
    var handleClick = function () {
        handleExecuteMutation({});
    };
    return (_jsxs(Popper, __assign({ className: "m-10 z-99", open: isOpen, arrow: true, anchorEl: anchorEl, placement: placement, disablePortal: true, modifiers: [
            {
                name: 'arrow',
                enabled: true,
                options: {
                    element: arrowRef
                }
            },
        ] }, { children: [_jsx(Arrow, { ref: setArrowRef, className: "MuiPopper-arrow" }, void 0), _jsx(Paper, __assign({ sx: { maxWidth: 240, backgroundColor: '#dbb400' } }, { children: _jsxs("div", __assign({ className: "flex w-full items-center p-10 flex-col space-y-20" }, { children: [_jsx("p", __assign({ className: "text-13 text-black" }, { children: t(text) }), void 0), _jsx(Button, __assign({ onClick: handleClick, type: "white sm" }, { children: t(buttonText) }), void 0)] }), void 0) }), void 0)] }), void 0));
};
export default NewFeaturePopper;
